import React, { createContext, useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import useFetch from "../../hooks/useFetch";
import sortOptions from "../../model/sortOptions";
import formatParams from "../../helpers/formatParams";

const Context = createContext();

export const ProductsProvider = ({ children, language, cta, cta2 }) => {
	const [params, setParams] = useState(
		window.location.search
			? new URLSearchParams(window.location.search)
			: new URLSearchParams({lang: language, pageNumber: 1})
	);
	const [filterParams] = useState(
		new URLSearchParams({
			type: "fphsg_product",
			lang: language,
		})
	);
	const [filterGroups] = useFetch(filterParams, language, "filters", null);

	const [items, message, totalPages, postCount] = useFetch(
		formatParams(params, filterGroups, true),
		language,
		"products",
		cta,
		cta2,
	);
	const [activeFilters, setActiveFilters] = useState([]);

	const labelText = () => {
		if (language === "en") {
			return "Default";
		}
		return "Défaut";
	};
	const [label, setLabel] = useState(labelText());
	const dialog = useRef(null);
	const [dialogIsOpen, setDialogIsOpen] = useState(false);

	useEffect(() => {
		const paramsStr = formatParams(params);
		window.history.pushState({ path: `?${paramsStr}` }, "", `?${paramsStr}`);
	}, [params]);


	// grabs the url search params object and sets them in the activeFilters array
	// on page load
	useEffect(() => {
		if (!filterGroups.length && !window.location.search) return;

		const url = new URL(window.location.href);
		let currentCategory = "";

		for (const [key, value] of url.searchParams.entries()) {
			if (currentCategory === key) return;
			currentCategory = key;
			const values = url.searchParams.get(key).split(",");

			setActiveFilters((currentValue) => {
				const activeFiltersCopy = [...currentValue];
				const filterGroup = filterGroups.find(group => group.slug === key || key === "supported");

				if (!filterGroup) return activeFiltersCopy;

				values.forEach(value => {
					const newValue = key === "supported" ? "bdc" : value;
					const filter = filterGroup.filters.find(filter => filter.slug === newValue);

					if (!filter) return activeFiltersCopy;

					activeFiltersCopy.push(filter.title);
				});

				return activeFiltersCopy;
			});
		}
	}, [filterGroups]);

	const data = {
		// data or state to be passed on to child components
		language,
		items,
		message,
		params,
		totalPages,
		activeFilters,
		postCount,
		filterGroups,
		sortOptions,
		label,
		labelText,
		dialog,
		dialogIsOpen,
	};

	const actions = {
		// handlers and mutation functions that would be passed down to components
		setParams,
		setActiveFilters,
		setLabel,
		setDialogIsOpen,
	};

	return (
		<Context.Provider value={{ actions, data }}>{children}</Context.Provider>
	);
};

ProductsProvider.propTypes = {
	children: PropTypes.any,
	language: PropTypes.string,
	cta: PropTypes.object,
	cta2: PropTypes.object,
};

export default Context;
